import { hasProductTag } from "@/entities/product"
import { EFFY_PACKAGE_PRODUCT_TAGS, type EffyPackage } from "@/features/effy/constants/effyPackage"
import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    quotedProduct: graphql(
        `
            fragment hasEffyPackageProduct_QuotedProduct on QuotedProduct {
                product {
                    ...hasProductTag_Product
                }
            }
        `,
        [hasProductTag.fragments.product]
    ),
}

// At least one quoted product must carry the package tag
// if it returns false, it could means new effy product are tagged with package tag
export function hasEffyPackageProduct(
    quotedProducts: FragmentOf<typeof graphQLFragments.quotedProduct>[],
    effyPackage: EffyPackage
) {
    const packageTag = EFFY_PACKAGE_PRODUCT_TAGS[effyPackage]

    return quotedProducts.some((quotedProduct) => {
        const { product } = readFragment(graphQLFragments.quotedProduct, quotedProduct)

        return !!product && hasProductTag(product, packageTag)
    })
}

hasEffyPackageProduct.fragments = graphQLFragments
